import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Target } from 'lucide-react';
import EmptyStateBlock from '../EmptyStateBlock';
import WalletTargetModal from './WalletTargetModal';
import { decryptToken } from '../utils/getToken';
import { toast } from 'react-toastify';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router-dom';

const WalletTarget = () => {
    const [loading, setLoading] = useState(false);
    const token = decryptToken("accessToken") || ""
    const url = API_BASE_URL
    const [target, setTarget] = useState([])
    const navigate=useNavigate();
    // Dummy wallet monthly targets
    // const dummyTargets = [
    //     { purchaseAmount: 1000, reward: "0.02%" },
    //     { purchaseAmount: 2000, reward: "0.5%" },
    //     { purchaseAmount: 5000, reward: "1%" },
    //     { purchaseAmount: 10000, reward: "2%" },
    //     { purchaseAmount: 20000, reward: "5%" },
    // ];

    // Referral usage data (kept if you want pagination later)
    const dummyUsage = [
        {
            referUserId: 1,
            usedUserId: 101,
            usedUserEmail: "alice@example.com",
            usedDate: "2025-09-10 14:32",
            prizeType: "amount",
            prizeValue: 100,
        },
        {
            referUserId: 1,
            usedUserId: 102,
            usedUserEmail: "bob@example.com",
            usedDate: "2025-09-12 10:15",
            prizeType: "percentage",
            prizeValue: 15,
        },
    ];

    // States for pagination
    const [usageData] = useState(target);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const totalPages = Math.ceil(usageData.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Modal states
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState({
        purchaseAmount: "",
        rewardPercentage: "",
        isActive: false,
        notifyUser: false,
        rewardAmount: "",
    });

    // ✅ Coin-to-Rupee conversion state
    const [coinValue, setCoinValue] = useState(1);
    const location = useLocation()

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("openWallet") === "true") {
            const newUrl = `${window.location.pathname}`;
            window.history.replaceState({}, "", newUrl);
            setIsModalOpen(true)
        }
    }, [location]);

    // Placeholder fetch function
    const sliderFetch = () => {
    };

    useEffect(() => {
        const fetchCoinValue = async () => {
            try {
                setLoading(true);
                const res = await axios.get(`${url}/coin`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (res.data?.data?.price) {
                    setCoinValue(res.data.data.price);
                }
            } catch (err) {
                console.error("Error fetching coin value:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchCoinValue();
    }, [token]);

    const fetchData = async () => {
        try {
            const response = await fetch(`${url}/referal-setting/getall`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            setTarget(res.data);
        } catch (error) {
            console.error(error)
        }
    }

    // 🔹 Handle save or update coin price
    const handleSaveCoin = async () => {
        if (!coinValue || parseFloat(coinValue) <= 0) {
            return toast.error("Please enter a valid coin value.");
        }

        try {
            setLoading(true);
            const res = await axios.post(
                `${url}/coin`,
                { price: coinValue },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            toast.success(res.data.message);
        } catch (err) {
            console.error("Error saving coin value:", err);
            toast.error(err.response?.data?.message || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {

        Swal.fire({
            title: "Are you sure?",
            text: "You won’t be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await axios.delete(
                        `${url}/referal-setting/${id}`,
                        {
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    );

                    toast.success(res.data.message || "Deleted successfully");
                    fetchData && fetchData(); // refresh table after delete

                    Swal.fire("Deleted!", "Referral setting has been deleted.", "success");
                } catch (error) {
                    console.error("Delete error:", error);
                    toast.error(error.response?.data?.message || "Failed to delete");
                }
            }
        });
    };

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <>

            <div className="oms-header">
                <h1 className="dashboard-title">Wallet</h1>
                <button
                        onClick={() => {
                            navigate("/wallet-history")

                        }}
                        className="oms-add-btn"
                    >
                        Reward History
                    </button>
            </div>

            {/* ✅ Coin Value Section */}
            <div className="mb-4 flex items-center gap-3">
                <label className="text-sm font-medium text-gray-700">
                    1 Coin =
                </label>
                <input
                    type="number"
                    min="0.01"
                    step="0.01"
                    value={coinValue}
                    onChange={(e) => setCoinValue(e.target.value)}
                    className="w-24 border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring focus:ring-blue-200"
                    disabled={loading}
                />
                <span className="text-sm text-gray-700">Rupee</span>

                <button
                    onClick={handleSaveCoin}
                    disabled={loading}
                    className="ml-4 px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 disabled:opacity-50"
                >
                    {loading ? "Saving..." : "Save"}
                </button>
            </div>

            {/* Wallet Monthly Targets */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Purchase Amount</th>
                            <th>Reward %</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {target.length > 0 ? (
                            target.map((t, i) => (
                                <tr key={i}>
                                    <td>
                                        ₹{t.purchase_amount} <br />
                                    </td>
                                    <td>{t.reward_percentage}</td>
                                    <td>
                                        <button
                                            className="edit-button"
                                            onClick={() => {
                                                setData({
                                                    id: t.id,
                                                    purchaseAmount: t.purchase_amount,
                                                    rewardPercentage: t.reward_percentage,
                                                });
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>

                                        <button
                                            className="delete-button"
                                            onClick={() => handleDelete(t.id)}
                                        >
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="p-4 align-middle">
                                    <EmptyStateBlock
                                        compact
                                        Icon={Target}
                                        title="No wallet targets"
                                        description="You have not set any purchase–reward tiers yet. Add a target to define referral rewards."
                                    />
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="pagination">
                    <button
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>
                    <button className="pagination-btn active">{currentPage}</button>
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>
                    <button
                        onClick={() => paginate(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}

            <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
                <button
                    onClick={() => {
                        setIsModalOpen(true)
                        setData({
                            id: "",
                            purchaseAmount: "",
                            rewardPercentage: "",
                        });

                    }}
                    className="cssbuttons-io-button">
                    <span>Add Target</span>
                </button>
            </div>

            {/* Modal */}
            <WalletTargetModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                data={data}
                setData={setData}
                fetchData={fetchData}
            />
        </>
    );
};

export default WalletTarget;
